import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';

import Button, { ButtonVariants } from 'modules/_shared/components/Buttons';

import { IncentiveOfferSellerParticipationLimits } from 'modules/incentivesMarket/types';

import BuyOfferSellerLimitsPanel from '../BuyOfferUnitsSection/BuyOfferSellerLimitsPanel';
import BuyOfferSellerLimitsPreview from '../BuyOfferUnitsSection/BuyOfferSellerLimitsPreview';

type SellerLimitsControlsProps = {
  sellerParticipationLimits: IncentiveOfferSellerParticipationLimits;
  sharesToTransfer: number;
  unitPrice: number;
  variant?: 'BUY' | 'SELL';
  availablePlanTypes?: string[];
  /* eslint-disable-next-line no-unused-vars */
  onChangeAllowSellAll: (allowSellAll: boolean) => void;
  /* eslint-disable-next-line no-unused-vars */
  onChangeSellerLimit: (
    field: keyof IncentiveOfferSellerParticipationLimits,
    value: number
  ) => void;
};

const SellerLimitsControls: FC<SellerLimitsControlsProps> = ({
  sellerParticipationLimits,
  sharesToTransfer,
  unitPrice,
  variant = 'BUY',
  availablePlanTypes,
  onChangeAllowSellAll,
  onChangeSellerLimit,
}) => {
  const { t } = useTranslate();
  const isCustomLimits = sellerParticipationLimits.allowSellAll === false;
  const isSell = variant === 'SELL';

  const titleKey = isSell
    ? 'IncentivesMarketSellerLimitsTitle_SELL'
    : 'IncentivesMarketSellerLimitsTitle';
  const descriptionKey = isSell
    ? 'IncentivesMarketSellerLimitsDescription_SELL'
    : 'IncentivesMarketSellerLimitsDescription';

  return (
    <>
      <div className="mb-3">
        <h6 className="overline-title text-soft mb-2">{t(titleKey)}</h6>
        <p className="text-soft fs-13px mb-3">{t(descriptionKey)}</p>

        <div className="d-flex w-100 mb-3" style={{ gap: '8px' }}>
          <Button
            className="flex-fill"
            onClick={() => onChangeAllowSellAll(true)}
            variant={
              !isCustomLimits ? ButtonVariants.PRIMARY : ButtonVariants.LIGHT
            }
            data-testid="seller-limits-no-cap"
          >
            <span className="text-center">
              {t('IncentivesMarketSellerLimitsNoCap')}
            </span>
          </Button>
          <Button
            className="flex-fill"
            onClick={() => onChangeAllowSellAll(false)}
            variant={
              isCustomLimits ? ButtonVariants.PRIMARY : ButtonVariants.LIGHT
            }
            data-testid="seller-limits-custom"
          >
            <span className="text-center">
              {t('IncentivesMarketSellerLimitsCustom')}
            </span>
          </Button>
        </div>

        {isCustomLimits && (
          <BuyOfferSellerLimitsPanel
            sellerParticipationLimits={sellerParticipationLimits}
            availablePlanTypes={availablePlanTypes}
            onChangeLimit={onChangeSellerLimit}
          />
        )}
      </div>

      <div className="row mt-3">
        <div className="col-12">
          <BuyOfferSellerLimitsPreview
            sellerParticipationLimits={sellerParticipationLimits}
            sharesToTransfer={sharesToTransfer}
            unitPrice={unitPrice}
            availablePlanTypes={availablePlanTypes}
          />
        </div>
      </div>
    </>
  );
};

export default SellerLimitsControls;
